<template>
    <div class="group">
        <div class="item" v-for="(item, index) in newsList[currentIdx].list" :key="index" @click="bindleClick(item.id)">
            <div class="item-left">
                <div class="title">
                    <img src="../../../assets/images/service/spirit/icon_yel.png" alt="">
                    <span>{{item.title}}</span>
                </div>
                <div class="dec-wrap">
                    <div class="tip">
                        <div class="dot-wrap">
                            <div class="dot"></div>
                        </div>
                        <div class="dec">{{item.dec}}</div>
                    </div>
                </div>
                <div class="time">{{item.time}}</div>
            </div>
            <div class="img">
                <img :src="item.img" alt="">
            </div>
        </div>
        <div class="pagination">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :page-size="10"
                :total="11">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                newsList:[
                    {
                        list: [
                            {
                                title: '中医药治郁有方，甘露海“天下无郁”公益活动关爱抑郁症人群',
                                dec: '随着生活节奏的不断加快，抑郁症以及相关的疾病也越来越被社会所重视。日前，甘露海携手郁金香陪伴举行了“天下无郁”系列公益活动，不仅为广大抑郁症患者树立抗击抑郁的信心，其间还提供咨询诊疗服务，帮助近50名抑郁症患者走出抑郁。此次活动不仅为广大抑郁症患者提供学习抑郁症治愈方法，组建了彼此交流鼓励的平台，还展现了中医药在治疗抑郁症方面的独特优势，进一步彰显了东方医学的价值魅力。',
                                time: '2021-09-28',
                                img: require('../../../assets/images/news/pic_11.png'),
                                id: 11
                            },
                            {
                                title: '920郁友节将至，甘露海启动“天下无郁”系列公益活动',
                                dec: '甘露海品牌将于9月20日开启“天下无郁”系列公益活动，并携手郁金香陪伴举办第三届“无郁中国”抑郁康复论坛暨920郁友节。',
                                time: '2021-09-18',
                                img: require('../../../assets/images/news/pic_1.png'),
                                id: 1
                            },
                            {
                                title: '国内首款小核酸中草药饮料上市，甘露海2911“喝”护健康',
                                dec: '近年来，国民健康意识不断提升，健康养生概念深入人心。在全球的抗“疫”战场，中医药也充分发挥特色优势成为抗击疫情的利器，贡献出对新冠肺炎有明显疗效的诸多方剂和中药品种。中草药饮料也正受到前所未有的重视和追捧，以天然、安全等特点成为消费“新宠”。',
                                time: '2021-09-13',
                                img: require('../../../assets/images/news/pic_2.png'),
                                id: 2
                            },
                            {
                                title: '首款小核酸饮料甘露海2911上市，捐赠5万盒守护抗疫天使',
                                dec: '自新冠肺炎疫情发生以来，中医药积极"亮剑"彰显特色，在治未病、传染病防治和卫生应急中的独特优势也被更多人所熟知。作为致力于推动中医药现代化发展的代表企业之一，甘露海品牌持续关注疫情的最新动态，充分发挥东方医学“治未病”的智慧，并结合现代科学技术，正式推出国内首款活性小核酸中草药饮料甘露海2911。9月9日，甘露海中医有限公司通过江苏省红十字会向江苏省人民医院捐赠总价值40万元的50000盒甘露海2911饮品，用于关爱慰问抗疫一线的医护人员。江苏省红十字会党组成员、副会长赵凯向甘露海中医有限公司CEO朱晨颁发了荣誉证书。',
                                time: '2021-09-09',
                                img: require('../../../assets/images/news/pic_3.png'),
                                id: 3
                            },
                            {
                                title: '超九成上班族身体亮红灯，甘露海三因疗法带你摆脱办公室病',
                                dec: '在如今快节奏的生活工作压力下，很多年轻人刚步入职场还没来得及体会升职加薪的快乐，身体却早早亮起了红灯。调查显示，约98.8%的都市白领都被“办公室病”缠上，几乎人人处于亚健康状态。由于长时间久坐不运动、饮食不健康、休息不规律，有越来越多的人感到身体疲劳困乏、心情抑郁、性情急躁易怒、记忆力减退、注意力不集中等，甚至患上了办公室病，如颈椎病、腰椎病、肩周炎、慢性疲劳综合症、慢性肠胃炎、胃溃疡、脂肪肝、便秘……严重影响生活和工作质量。',
                                time: '2021-09-09',
                                img: require('../../../assets/images/news/pic_4.png'),
                                id: 4
                            },
                            {
                                title: '甘露海入驻成都天府国际生物城，科技创新助力藏医药现代化发展',
                                dec: '9月1日，为推动藏医药科技进步，促进藏药生产现代化发展落到实处，甘露海品牌正式入驻成都天府国际生物城，并与生物城联东U谷科创中心正式签约。甘露海中医有限公司副总裁黄瑶、甘露海药业有限公司副总经理杨永杰出席签约仪式。',
                                time: '2021-09-01',
                                img: require('../../../assets/images/news/pic_5.png'),
                                id: 5
                            },
                            {
                                title: '抑郁症“年轻化”趋势加剧，甘露海三因疗法创新破局',
                                dec: '随着经济社会的快速转型和生活节奏的明显加快，焦虑、抑郁等问题日渐成为现代人的健康隐忧。调查发现，在各年龄段人群中，18-34岁青年的焦虑平均水平高于成人期的其他年龄段，同时他们也是酒精、失眠或疼痛药物使用障碍发病率最高的群体。',
                                time: '2021-08-24',
                                img: require('../../../assets/images/news/pic_6.png'),
                                id: 6
                            },
                            {
                                title: '挖掘藏医药“宝藏”，“甘露海三因疗法”治病更养心',
                                dec: '《中餐厅5》近期开播，首次参加综艺真人秀的丁真再次成为关注焦点，而首期节目中黄晓明误以为丁真是西藏人的话题，引发不少网友主动对四川省甘孜藏族自治州理塘县的“科普”。正是丁真的走红，让理塘县这座海拔4000米的县城走到了聚光灯下，雪山、冰川、草原、白塔......绝美的自然风光引人入胜。',
                                time: '2021-08-05',
                                img: require('../../../assets/images/news/pic_7.png'),
                                id: 7
                            },
                            {
                                title: '硬核！甘露海藏医院同时获得AAA信用等级与ISO9001质量认证',
                                dec: '近日，成都武侯甘露海藏医院有限公司（甘露海藏医院）被认定为最高等级的AAA级企业信用等级。同一时间，甘露海藏医院还通过了ISO9001质量体系认证。双喜临门彰显了甘露海藏医院拥有的硬核实力以及高速发展的蓬勃气势。',
                                time: '2021-07-13',
                                img: require('../../../assets/images/news/pic_8.png'),
                                id: 8
                            },
                            {
                                title: '传承“非遗”藏药浴，甘露海持续推动藏医学现代化发展',
                                dec: '一提起“非遗”，你想到什么？是3000多岁的古琴、中医针灸和中国篆刻，还是人尽皆知的“二十四节气”、“中国书法”和“中国珠算”？ 在很多人印象里，“非遗”是神秘、严肃、传统、和现代社会略有脱节的“艺术”。然而随着国家的重视和发展，更多的文化和自然遗产从历史中走来，在现代生活中绽放光彩。',
                                time: '2021-06-11',
                                img: require('../../../assets/images/news/pic_9.png'),
                                id: 9
                            },
                        ]
                    },
                    {
                        list: [
                            {
                                title: '甘露海助力藏医药加速发展， 四川藏药材及藏药制剂标准出台',
                                dec: '日前，由甘露海藏医院杨宝寿院长担任专家组成员、深度参与并作出突出贡献编撰而成的《四川省藏药材标准》（2020年版）以及《四川省医疗机构藏药制剂标准》（2020年版）已经正式公布，经四川省药品监督管理局2021年第1次局长办公会审议通过，将于2021年8月1日起实施。',
                                time: '2021-04-12',
                                img: require('../../../assets/images/news/pic_10.png'),
                                id: 10
                            }
                        ]
                    }
                ],
                currentIdx: 0
            }
        },
        methods: {
            handleCurrentChange(val) {
                console.log(val)
                this.currentIdx = val - 1
            },
            bindleClick(id) {
                let routeData = this.$router.resolve({path: '/articles', query: { page: id }})
                window.open(routeData.href, '_blank');
            }
        }
    }
</script>
<style lang="scss" scoped>
    .group {
        padding: 20px 360px;
        background: #fff;
        .item {
            display: flex;
            border-bottom: 1px solid #EEEEEE;
            padding: 50px 0;
            cursor: pointer;
            .item-left {
                flex: 1;
                position: relative;
                .time {
                    position: absolute;
                    bottom: 0;
                    left: 20px;
                    color: #999999;
                    font-size: 14px;
                }
            }
            .title {
                display: flex;
                align-items: center;
                img {
                    width: 22px;
                    height: 22px;
                }
                span {
                    color: #333333;
                    font-size: 24px;
                    margin-left: 14px;
                    font-weight: bold;
                }
            }
            .dec-wrap {
                margin-top: 20px;
                .tip {
                    // margin-top: 20px;
                    color: #666666;
                    font-size: 18px;
                    display: flex;
                    .dot-wrap {
                        width: 22px;
                        height: 22px;
                        margin-right: 13px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .dot {
                        width: 6px;
                        height: 6px;
                        background: #DBA513;
                        border-radius: 50%;
                        margin-top: 12px;
                    }
                    }
                    .dec {
                        // line-height: 36px;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                }
            }
            .img {
                margin-left: 76px;
                img {
                    width: 360px;
                    height: 216px;
                    transition: all 0.6s ease;
                    // box-shadow: 10px 10px 5px rgba($color: #888, $alpha: 0.3);
                }
            }
        }
        .item:hover .img > img {
            transform: translateX(-10px);
        }
        // .item:last-child {
        //     border-bottom: none;
        // }
        .pagination {
            display: flex;
            justify-content: center;
            padding: 30px 0;
        }
    }
</style>